
      <template>
  <div>
    <register-header></register-header>
    <div class="main-container-wrapper">
      <el-card class="cardd" shadow="never">
        <div class="register">
          <span @click="farenzhuce">个人注册</span>
          |
          <span :class="{ active: action }">法人注册</span>
        </div>
        <div style="margin: 30px 0">
          <el-steps
            space="100%"
            :active="numActi"
            finish-status="success"
            align-center
          >
            <el-step title="单位信息"></el-step>
            <el-step title="法定代表人"></el-step>
            <el-step title="单位经办人"></el-step>
            <el-step title="账号信息"></el-step>
            <el-step title="注册成功"></el-step>
          </el-steps>
        </div>

        <div class="formSty heiCen" v-show="oneJD" :style="defaultHeight">
          <el-form
            :rules="rules1"
            label-position="right"
            ref="applyForm1"
            :model="applyForm"
            label-width="160px"
          >
            <el-form-item label="单位名称" prop="belongInst">
              <el-input v-model="applyForm.belongInst"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="socialUnifiedCredit">
              <el-input v-model="applyForm.socialUnifiedCredit"></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="districtCode">
              <el-select
                v-model="applyForm.districtCode"
                style="width: 33%; margin-right: 0.5%"
                placeholder="省"
                @change="districtCodeChange()"
              >
                <el-option
                  v-for="item in applyForm.districtCodeList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
              <el-select
                v-model="applyForm.pendingDisposalNum"
                style="width: 33%; margin-right: 0.5%"
                placeholder="市"
                @change="pendingDisposalNumChange()"
              >
                <el-option
                  v-for="item in applyForm.pendingDisposalNumList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
              <el-select
                v-model="applyForm.processedNum"
                style="width: 33%"
                placeholder="县"
              >
                <el-option
                  v-for="item in applyForm.processedNumList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位地址" prop="address">
              <el-input v-model="applyForm.address"></el-input>
            </el-form-item>
            <el-form-item label="经济性质">
              <el-input v-model="applyForm.economicNature"></el-input>
            </el-form-item>
            <el-form-item label="主管部门">
              <el-input v-model="applyForm.mngDepartment"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="licenseList">
              <span style="font-size: 10px; color: #b71c1c; margin: 0">
                提示：企业法人营业执照副本复印件(或事业单位主管机关颁发的单位法人证书或文件的复印件)
              </span>
              <el-upload
                ref="applyForm"
                list-type="picture-card"
                :class="{ disabled: uploadDisabled }"
                :action="uploadUrl"
                :data="uploadData"
                :file-list="applyForm.licenseList"
                :on-success="successLicenseList"
                :before-upload="beforeLicenseList"
                :on-preview="previewLicenseList"
                :before-remove="removeLicenseList"
                accept=".jpg,.png,.bmp"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="font-size: 10px; color: #b71c1c; margin: 0"
                >支持扩展名：.jpg .png .bmp</span
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="formSty heiCen" v-show="twoJD" :style="defaultHeight">
          <el-form
            :rules="rules2"
            label-position="right"
            ref="applyForm2"
            :model="applyForm"
            label-width="120px"
          >
            <el-form-item label="法定代表人" prop="legalRepresentative">
              <el-input v-model="applyForm.legalRepresentative"></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificateNum">
              <el-select
                v-model="applyForm.certificateTypeCode"
                style="width: 30%"
                @change="certificateTypeCodeChange()"
              >
                <el-option
                  v-for="item in applyForm.certificateTypeCodeList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dataCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="applyForm.certificateNum"
                @change="certificateNumChange()"
                style="width: 65%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证件有效期"
              v-show="applyForm.certificateTypeCode == '0'"
            >
              <el-col :span="9">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  popper-class="timeclass"
                  v-model="applyForm.termStart"
                  style="width: 100%"
                  :picker-options="startOption"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 2%" class="line" :span="1">至</el-col>
              <el-col :span="9">
                <el-date-picker
                  :disabled="termEndDis"
                  type="date"
                  placeholder="选择日期"
                  v-model="applyForm.termEnd"
                  popper-class="timeclass"
                  style="width: 100%"
                  :picker-options="endOption"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 4%" :span="2">
                <el-checkbox
                  v-model="applyForm.isLongTerm"
                  @change="isLongTermChange()"
                  >永久</el-checkbox
                >
              </el-col>
            </el-form-item>
            <el-form-item label="证件扫描件" prop="scanningCopy">
              <span style="font-size: 10px; color: #b71c1c; margin: 0">
                上传证件扫描件（身份证上传正反面）
              </span>
              <el-upload
                ref="applyForm"
                list-type="picture-card"
                :limit="2"
                :on-exceed="masterFileMax2"
                :action="uploadUrl"
                :data="uploadData"
                :file-list="applyForm.scanningCopy"
                :on-success="successScanningCopy"
                :before-upload="beforeScanningCopy"
                :on-preview="previewScanningCopy"
                :before-remove="removeScanningCopy"
                accept=".jpg,.png,.bmp"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="font-size: 10px; color: #b71c1c; margin: 0"
                >支持扩展名：.jpg .png .bmp</span
              >
            </el-form-item>
            <el-form-item label="手机号码" prop="telNo">
              <el-input
                placeholder="请输入内容"
                v-model="applyForm.telNo"
                style="width: 60%; vertical-align: middle"
                @change="numVerification1()"
              >
                <el-button
                  slot="append"
                  class="verification"
                  type="primary"
                  ref="append"
                  @click="verCode"
                  >{{ inner }}</el-button
                >
              </el-input>
              <el-input
                placeholder="输入验证码"
                v-model="verificationCode"
                style="width: 35%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="applyForm.email"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          class="main-container-wrapper heiCen2"
          v-show="threeJD"
          :style="defaultHeight"
        >
          <el-button
            icon="el-icon-circle-plus-outline"
            type="primary"
            @click="addHandler()"
            >添加经办人</el-button
          >
          <div style="padding: 0 20px; text-align: center; margin-top: 20px">
            <el-table
              :data="applyForm.legalForms"
              :stripe="true"
              :border="true"
              :header-cell-style="{
                background: '#f5f7fa',
                color: '#909399',
                borderColor: 'grey',
              }"
              :cell-style="{ borderColor: 'grey' }"
            >
              <el-table-column
                align="center"
                type="index"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="legalRepresentative"
                label="经办人"
                min-width="150px"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="certificateNum"
                label="证件号码"
                min-width="220px"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="telNo"
                label="电话"
                min-width="220px"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="email"
                label="邮箱"
                min-width="220px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="操作"
                min-width="220px"
              >
                <template slot-scope="{ row, $index }">
                  <button
                    v-if="row.type === '1'"
                    class="seeBtn"
                    @click="seeUpdate(row, $index)"
                  >
                    查看
                  </button>
                  <div v-else>
                    <button class="seeBtn" @click="modifyUpdate(row, $index)">
                      修改
                    </button>
                    <button
                      style="margin-left: 10px"
                      class="seeBtn"
                      @click="del(row, $index)"
                    >
                      删除
                    </button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="formSty heiCen2" v-show="fourJD" :style="defaultHeight">
          <el-form
            :rules="rules3"
            label-position="right"
            ref="applyForm3"
            :model="applyForm"
            label-width="100px"
          >
            <el-form-item label="用户账号" prop="userName">
              <el-input
                v-model="applyForm.userName"
                @blur="userNameChange()"
              ></el-input>
            </el-form-item>
            <el-form-item label="账号密码" prop="cypher">
              <el-input
                v-model="applyForm.cypher"
                show-password
                placeholder="6~16位字符，至少包含三种元素：数字、大写字母、小写字母或特殊字符"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="isPassword">
              <el-input
                v-model="applyForm.isPassword"
                show-password
                @change="isPasswordChange()"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="formSty1 heiCen2" v-show="fiveJD" :style="defaultHeight">
          <div style="font-size: 30px; color: #67c23a; font-weight: 700">
            注册成功
          </div>
          <p style="font-size: 20px">
            恭喜您,<span style="color: #2264a0">{{ applyForm.userName }}</span>
            已注册成功
          </p>
          <p style="font-size: 16px">请根据提示操作</p>
          <el-button @click="goBack">返回首页</el-button>
          <el-button style="margin-left: 15px" @click="personal"
            >返回个人登录</el-button
          >
        </div>
      </el-card>
    </div>
    <div class="foot">
      <el-divider></el-divider>
      <el-checkbox
        style="margin-bottom: 20px"
        v-model="checked"
        v-show="checkedwfa"
        >我已阅读并同意
        <span @click="spanDis = true">{{ span }}</span></el-checkbox
      ><br />
      <el-button @click="prev()" v-show="preJD">上一步</el-button>
      <el-button @click="next1('applyForm1')" v-show="this.numActi === 0"
        >下一步</el-button
      >
      <el-button @click="next2('applyForm2')" v-show="this.numActi === 1"
        >下一步</el-button
      >
      <el-button @click="next3()" v-show="this.numActi === 2">下一步</el-button>
      <el-button @click="regi('applyForm3')" v-show="goJD">注册</el-button>
    </div>
    <register-footer></register-footer>
    <!-- 提示手机号 -->
    <el-dialog title="提示" :visible.sync="phoneDis" width="30%" center>
      <span> 请输入手机号码 </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="phoneDis = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 增加经办人 -->
    <el-dialog :visible.sync="addBtn" width="70%" center>
      <div style="text-align: center" slot="title">
        <span style="font-size: 14px; font-weight: 700">增加经办人</span>
      </div>
      <el-card class="box-card" shadow="never">
        <el-scrollbar style="height: 450px; padding: 0 20px">
          <el-form
            :rules="rules4"
            label-position="right"
            ref="addApplyForm4"
            :model="addApplyForm"
            label-width="140px"
          >
            <el-form-item label="经办人姓名" prop="legalRepresentative">
              <el-input v-model="addApplyForm.legalRepresentative"></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificateNum">
              <el-select
                v-model="addApplyForm.certificateTypeCode"
                style="width: 30%"
                @change="certificateTypeCodeChange1()"
              >
                <el-option
                  v-for="item in addApplyForm.certificateTypeCodeList"
                  :key="item.dataCode"
                  :label="item.dataName"
                  :value="item.dataCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="addApplyForm.certificateNum"
                @change="certificateNumChange1()"
                style="width: 65%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证件有效期"
              v-show="addApplyForm.certificateTypeCode == '0'"
            >
              <el-col :span="9">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  popper-class="timeclass"
                  v-model="addApplyForm.termStart"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 2%" class="line" :span="1">至</el-col>
              <el-col :span="9">
                <el-date-picker
                  :disabled="termEndDis1"
                  type="date"
                  placeholder="选择日期"
                  v-model="addApplyForm.termEnd"
                  popper-class="timeclass"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 4%" :span="2">
                <el-checkbox
                  v-model="addApplyForm.isLongTerm"
                  @change="isLongTermChange1()"
                  >永久</el-checkbox
                >
              </el-col>
            </el-form-item>
            <el-form-item label="证件扫描件" prop="scanningCopy">
              <span style="font-size: 10px; color: #b71c1c; margin: 0">
                上传证件扫描件（身份证上传正反面）
              </span>
              <el-upload
                ref="addApplyForm"
                list-type="picture-card"
                :limit="2"
                :on-exceed="masterFileMax3"
                :action="uploadUrl"
                :data="uploadData"
                :file-list="addApplyForm.scanningCopy"
                :on-success="successScanningCopy1"
                :before-upload="beforeScanningCopy1"
                :on-preview="previewScanningCopy1"
                :before-remove="removeScanningCopy1"
                accept=".jpg,.png,.bmp"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="font-size: 10px; color: #b71c1c; margin: 0"
                >支持扩展名：.jpg .png .bmp</span
              >
            </el-form-item>
            <el-form-item label="上传授权书扫描件" prop="licenseList">
              <div class="file-upload">
                <el-upload
                  ref="addApplyForm"
                  :limit="1"
                  :on-exceed="masterFileMax"
                  :action="uploadUrl"
                  :data="uploadData"
                  :file-list="addApplyForm.licenseList"
                  :on-success="successLicenseList1"
                  :before-remove="removeLicenseList1"
                  :before-upload="beforeLicenseList1"
                  accept=".doc,.docx,.pdf"
                >
                  <el-button type="primary">上传授权书扫描件</el-button>
                  <span style="margin-left: 10px"
                    >支持扩展名：doc / docx/ pdf</span
                  >
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="手机号码" prop="telNo">
              <el-input
                placeholder="请输入内容"
                v-model="addApplyForm.telNo"
                @change="numVerification2()"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="addApplyForm.email"></el-input>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="yesAdd('addApplyForm4')"
          >确 定</el-button
        >
        <el-button type="success" @click="noAdd()">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 查看经办人 -->
    <el-dialog :visible.sync="seeBtn" width="70%" center>
      <div style="text-align: center" slot="title">
        <span style="font-size: 14px; font-weight: 700">查看经办人</span>
      </div>
      <el-card class="box-card" shadow="never">
        <el-scrollbar style="height: 450px; padding: 0 20px">
          <el-form
            label-position="right"
            ref="applyForm"
            :model="applyForm"
            label-width="130px"
          >
            <el-form-item label="经办人姓名" prop="legalRepresentative">
              <el-input
                readonly
                v-model="applyForm.legalRepresentative"
              ></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificateNum">
              <el-select
                v-model="applyForm.certificateTypeCode"
                readonly
                style="width: 30%"
              >
                <el-option
                  v-for="item in applyForm.certificateTypeCodeList"
                  :key="item.dataCode"
                  readonly
                  :label="item.dataName"
                  :value="item.dataCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="applyForm.certificateNum"
                readonly
                style="width: 65%; margin-left: 5%"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证件有效期"
              prop="termStart"
              v-show="applyForm.certificateTypeCode == '0'"
            >
              <el-col :span="9">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  popper-class="timeclass"
                  readonly
                  v-model="applyForm.termStart"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 2%" class="line" :span="1">至</el-col>
              <el-col :span="9">
                <el-date-picker
                  :disabled="termEndDis1"
                  type="date"
                  placeholder="选择日期"
                  readonly
                  v-model="applyForm.termEnd"
                  popper-class="timeclass"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col style="margin-left: 4%" :span="2">
                <el-checkbox
                  v-model="applyForm.isLongTerm"
                  disabled
                  @change="isLongTermChange1()"
                  >永久</el-checkbox
                >
              </el-col>
            </el-form-item>
            <el-form-item label="证件扫描件">
              <span style="font-size: 10px; color: #b71c1c; margin: 0">
                上传证件扫描件（身份证上传正反面）
              </span>
              <el-upload
                :disabled="true"
                ref="upload1"
                list-type="picture-card"
                :limit="2"
                :on-exceed="masterFileMax1"
                :action="uploadUrl"
                :data="uploadData"
                :file-list="applyForm.scanningCopy"
                :on-preview="previewScanningCopy1"
                accept=".jpg,.png,.bmp"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="font-size: 10px; color: #b71c1c; margin: 0"
                >支持扩展名：.jpg .png .bmp</span
              >
            </el-form-item>
            <el-form-item label="上传授权书扫描件">
              <div class="file-upload">
                <el-upload
                  :disabled="true"
                  ref="applyForm"
                  :action="uploadUrl"
                  :data="uploadData"
                  :file-list="applyForm.licenseList"
                  accept=".doc,.docx,.pdf"
                >
                  <el-button type="primary">上传授权书扫描件</el-button>
                  <span style="margin-left: 10px"
                    >支持扩展名：doc / docx/ pdf</span
                  >
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="手机号码" prop="telNo">
              <el-input
                readonly
                placeholder="请输入内容"
                v-model="applyForm.telNo"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="applyForm.email" readonly></el-input>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="seeBtn = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="注册协议和隐私条款"
      :visible.sync="spanDis"
      width="50%"
      center
    >
      <bps-bps></bps-bps>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="30%" center>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" width="30%" center>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible3" width="30%" center>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import registerHeader from "../../components/registerHeader.vue";
import registerFooter from "../../components/registerFooter.vue";
import { Message } from "element-ui";
import md5 from "js-md5";
import util from "../../utils/util";
import bpsBps from "../bps/bpsBps.vue";
import { uploadUrl } from "../../utils/upload";
import { url } from "../../utils/axiosUrl";
import {
  legalPersonRegistration1,
  legalPersonRegistration2,
  legalPersonRegistration3,
  legalPersonRegistration4,
} from "../../utils/formValidation";

export default {
  name: "IndividualRegistration",
  data() {
    return {
      url: url,
      //日期选择限制
      startOption: {
        // 指定开始限制时间
        disabledDate: (date) => {
          return date >= Date.now()
        }
      },
      endOption: {
        // 指定终止日期
        disabledDate: (date) => {
          return date <= Date.now()
        }
      },
      // 表单验证
      rules1: legalPersonRegistration1,
      rules2: legalPersonRegistration2,
      rules3: legalPersonRegistration3,
      rules4: legalPersonRegistration4,
      // 上传地址
      uploadUrl: uploadUrl,
      // 关于第一步上传控制
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      // 关于高度自适应
      defaultHeight: {
        height: "",
      },
      // 判断手机倒计时不可点击
      show: false,
      // 倒计时
      inner: "发送验证码",
      // 验证码内容
      verificationCode: null,
      // 表单验证
      // rules: legalPersonRegistration,
      span: "《注册协议和隐私条款》",
      // 判断手机验证码无号码弹窗
      phoneDis: false,
      // 判断注册协议显示
      spanDis: false,

      //   判断个人注册
      action: true,
      //   判断步骤
      numActi: 0,
      // 五阶段控制显示页面
      oneJD: true,
      twoJD: false,
      threeJD: false,
      fourJD: false,
      fiveJD: false,
      // 下一步
      nextJD: true,
      // 上一步
      preJD: false,
      // 注册
      goJD: false,
      // 返回登录
      dengJD: false,
      // 正常
      applyForm: {
        legalForms: [],
        userType: "organization",
        id: null,
        // 第一阶段========================================
        // 归属单位
        belongInst: null,
        // 社会统一信用代码
        socialUnifiedCredit: null,
        // 省
        districtCode: null,
        districtCodeList: [],
        // 市
        pendingDisposalNum: null,
        pendingDisposalNumList: [],
        // 县
        processedNum: null,
        processedNumList: [],
        // 经济性质
        economicNature: null,
        // 主管部门
        mngDepartment: null,
        // 营业执照
        licenseList: [],
        // 地址
        address: null,
        // 第二阶段========================================
        // 法定代表人
        legalRepresentative: null,
        // 证件类型编码
        certificateTypeCode: "0",
        certificateTypeCodeList: [],
        // 证件类型名称
        certificateTypeName: null,
        // 证件扫描件
        scanningCopy: [],
        // 证件号
        certificateNum: null,
        // 有效启始
        termStart: null,
        // 有效结束
        termEnd: null,
        // 是否永久
        isLongTerm: false,
        // 手机号
        telNo: null,
        // 电子邮箱
        email: null,
        // 第三阶段========================================

        // 表格
        // 第四阶段========================================
        // 账号
        userName: null,
        // 明文密码
        cypher: null,
        // md5密码
        password: null,
        // base64密码
        basePassword: null,
        // 确认密码
        isPassword: null,
        type: "1",
        a: [],
      },
      // 添加经办人
      addApplyForm: {
        id: null,
        // 营业执照
        licenseList: [],
        // 法定代表人
        legalRepresentative: null,
        // 证件类型编码
        certificateTypeCode: "0",
        certificateTypeCodeList: [],
        // 证件类型名称
        certificateTypeName: null,
        // 证件扫描件
        scanningCopy: [],
        // 证件号
        certificateNum: null,
        // 有效启始
        termStart: null,
        // 有效结束
        termEnd: null,
        // 是否永久
        isLongTerm: false,
        // 手机号
        telNo: null,
        // 电子邮箱
        email: null,
      },
      // 表格查看
      seeBtn: false,
      // 表格新增
      addBtn: false,
      // 上传文件
      uploadData: {
        file: "",
        BId: "",
        fileType: "",
        storeType: 3,
      },
      picUrl: "",
      // 控制只添加一张文件图片
      uploadDisabled: false,
      // 控制结束日期的disabled
      termEndDis: false,
      // 添加经办人控制结束日期的disabled
      termEndDis1: false,
      // 判断是增加还是修改
      addOrUpdateAgent: "add",
      // 获取当前数据并添加
      tableId: "",
      // 判断增加还是修改
      addWait: "1",
      checked: true,
      checkedwfa: false,
      // 第二步身份证通过才能下一步
      id1: false,
      id2: false,
      id3: false,
      scanningCopy: [],
    };
  },
  components: {
    registerHeader,
    registerFooter,
    bpsBps,
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getId();
    this.getHeight();
    this.getIdentityList();
    this.getProvinceList();
  },
  methods: {
    // 获取身份证件列表
    getIdentityList() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/framework/findIdType").then((res) => {
        if (res.status === 200) {
          this.applyForm.certificateTypeCodeList = res.data;
          this.addApplyForm.certificateTypeCodeList = res.data;
        }
      });
    },
    // 点击永久隐藏结束日期
    isLongTermChange() {
      if (this.applyForm.isLongTerm === true) {
        this.applyForm.termEnd = null;
        this.termEndDis = true;
      } else {
        this.termEndDis = false;
      }
    },
    // 添加经办人点击永久隐藏结束日期
    isLongTermChange1() {
      if (this.addApplyForm.isLongTerm === true) {
        this.addApplyForm.termEnd = null;
        this.termEndDis1 = true;
      } else {
        this.termEndDis1 = false;
      }
    },
    // 改变身份证明清空身份证号
    certificateTypeCodeChange() {
      this.applyForm.certificateNum = null;
    },
    // 第二步的身份证验证
    certificateNumChange() {
      if (this.applyForm.certificateTypeCode === "0") {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(this.applyForm.certificateNum) == true) {
          this.id1 = true;
        } else {
          Message.error("证件号码格式错误!");
        }
      }
    },
    // 增加经办人的身份证验证
    certificateNumChange1() {
      if (this.addApplyForm.certificateTypeCode === "0") {
        let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(this.addApplyForm.certificateNum) == true) {
          this.id2 = true;
        } else {
          Message.error("证件号码格式错误!");
        }
      }
    },
    // 添加经办人改变身份证明清空身份证号
    certificateTypeCodeChange1() {
      this.addApplyForm.certificateNum = null;
    },
    // 获取id
    getId() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/api/common/getId").then((res) => {
        this.applyForm.id = res.data;
      });
    },
    //第三步添加经办人上传授权书扫描件移除文件
    removeLicenseList1(file) {
      if (file && file.status === "success") {
        let Url = util.getAjaxUrl("axiosOne");
        this.$http
          .delete(Url + `/api/deleteFileStoreById/${file.id}`)
          .then((res) => {
            if (res.status == 200) {
              const index = this.addApplyForm.licenseList.indexOf(file);
              if (index !== -1) {
                this.addApplyForm.licenseList.splice(index, 1);
                this.uploadDisabled = false;
              }
            }
          });
      }
    },
    //第三步添加经办人上传授权书扫描件上传成功
    successLicenseList1(response, file, fileList) {
      const filePath = response.filePath;
      const name = response.fileOrigName;
      const id = response.id;
      const fileUrl = response.fileUrl;
      const item = {
        filePath: filePath,
        name: name,
        id: id,
        url: fileUrl,
      };
      this.addApplyForm.licenseList.push(item);

      this.$refs.addApplyForm4.validateField("licenseList");
    },
    //第三步添加经办人上传授权书扫描件上传文件之前
    beforeLicenseList1(file) {
      if (this.$util.judgeFileType(file, ["doc", "docx", "pdf"]) === -1) {
        this.$message.error("上传文件类型错误!");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 > 20;
      if (!fileSize) {
        this.uploadData = {
          file: file.name,
          BId: this.addApplyForm.id,
          fileType: "register",
          storeType: 3,
        };

        let promise = new Promise((resolve) => {
          this.$nextTick(function () {
            resolve(true);
          });
        });
        return promise; //通过返回一个promis对象解决
      } else {
        this.$Message.warning("上传文件大小不能超过20Mb!");
      }
    },
    // 第三步添加经办人控制预览
    previewScanningCopy1(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible3 = true;
    },
    // 第三步添加经办人移除文件
    removeScanningCopy1(file) {
      if (file && file.status === "success") {
        let id;
        if (this.addWait === "1") {
          id = file.response.id;
        }
        if (this.addWait === "2") {
          id = file.id;
        }
        let Url = util.getAjaxUrl("axiosOne");
        this.$http
          .delete(Url + `/api/deleteFileStoreById/${id}`)
          .then((res) => {
            if (res.status == 200) {
              const index = this.addApplyForm.scanningCopy.indexOf(file);
              if (index !== -1) {
                this.addApplyForm.scanningCopy.splice(index, 1);
              }
            }
          });
      }
    },
    //第三步添加经办人上传成功
    successScanningCopy1(response, file, fileList) {
      this.addApplyForm.scanningCopy = fileList;
      this.$refs.addApplyForm4.validateField("scanningCopy");
    },
    // 第三步添加经办人上传文件之前
    beforeScanningCopy1(file) {
      if (this.$util.judgeFileType(file, ["jpg", "png", "bmp"]) === -1) {
        this.$message.error("上传文件类型错误!");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 > 20;
      if (!fileSize) {
        this.uploadData = {
          file: file.name,
          BId: this.addApplyForm.id,
          fileType: "registerCard",
          storeType: "0",
        };
        let promise = new Promise((resolve) => {
          this.$nextTick(function () {
            resolve(true);
          });
        });
        return promise; //通过返回一个promis对象解决
      } else {
        $Message.warning("上传文件大小不能超过20Mb!");
      }
    },
    // 最多上传上限
    masterFileMax(files, fileList) {
      this.$message.warning(`请最多上传1个文件。`);
    },
    // 最多上传上限
    masterFileMax1(files, fileList) {
      this.$message.warning(`请最多上传2个文件。`);
    },
    // 最多上传上限
    masterFileMax2(files, fileList) {
      this.$message.warning(`请最多上传2个文件。`);
    },
    // 最多上传上限
    masterFileMax3(files, fileList) {
      this.$message.warning(`请最多上传2个文件。`);
    },
    // 第二步证件扫描件控制预览
    previewScanningCopy(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    // 第二步证件扫描件移除文件
    removeScanningCopy(file) {
      if (file && file.status === "success") {
        let id = file.response.id;
        if (file.response) {
          let Url = util.getAjaxUrl("axiosOne");
          this.$http
            .delete(Url + `/api/deleteFileStoreById/${id}`)
            .then((res) => {
              if (res.status == 200) {
                const index = this.applyForm.scanningCopy.indexOf(file);
                if (index !== -1) {
                  this.applyForm.scanningCopy.splice(index, 1);
                }
              }
            });
        }
      }
    },
    //第二步证件扫描件上传成功
    successScanningCopy(response, file, fileList) {
      this.applyForm.scanningCopy = fileList;
      fileList.map((item) => {
        this.picUrl = item.response.filePath;
      });
      this.$refs.applyForm2.validateField("scanningCopy");
    },
    // 第二步证件扫描件上传文件之前
    beforeScanningCopy(file) {
      if (this.$util.judgeFileType(file, ["jpg", "png", "bmp"]) === -1) {
        this.$message.error("上传文件类型错误!");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 > 20;
      if (!fileSize) {
        this.uploadData = {
          file: file.name,
          BId: this.applyForm.id,
          fileType: "registerCard",
          storeType: "0",
        };
        let promise = new Promise((resolve) => {
          this.$nextTick(function () {
            resolve(true);
          });
        });
        return promise; //通过返回一个promis对象解决
      } else {
        this.$Message.warning("上传文件大小不能超过20Mb!");
      }
    },
    // 第一步营业执照控制预览
    previewLicenseList(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
      this.uploadDisabled = true;
    },
    // 第一步营业执照移除文件
    removeLicenseList(file) {
      if (file && file.status === "success") {
        let id = file.response.id;
        if (file.response) {
          let Url = util.getAjaxUrl("axiosOne");
          this.$http
            .delete(Url + `/api/deleteFileStoreById/${id}`)
            .then((res) => {
              if (res.status == 200) {
                const index = this.applyForm.licenseList.indexOf(file);
                if (index !== -1) {
                  this.applyForm.licenseList.splice(index, 1);
                  this.uploadDisabled = false;
                }
              }
            });
        }
      }
    },
    //第一步营业执照上传成功
    successLicenseList(response, file, fileList) {
      this.applyForm.licenseList = fileList;
      fileList.map((item) => {
        this.picUrl = item.response.filePath;
        this.uploadDisabled = true;
      });
      this.$refs.applyForm1.validateField("licenseList");
    },
    // 第一步营业执照上传文件之前
    beforeLicenseList(file) {
      if (this.$util.judgeFileType(file, ["jpg", "png", "bmp"]) === -1) {
        this.$message.error("上传文件类型错误!");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 > 20;
      if (!fileSize) {
        this.uploadData = {
          file: file.name,
          BId: this.applyForm.id,
          fileType: "register",
          storeType: 0,
        };
        let promise = new Promise((resolve) => {
          this.$nextTick(function () {
            resolve(true);
          });
        });
        return promise; //通过返回一个promis对象解决
      } else {
        this.$Message.warning("上传文件大小不能超过20Mb!");
      }
    },
    // 中间部分自适应
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 300 + "px";
    },
    // 手机验证码
    verCode() {
      this.numVerification1();
      if (this.applyForm.telNo == null) {
        this.phoneDis = true;
      } else {
        if (!/^1[34578]\d{9}$/.test(this.applyForm.telNo)) {
          Message.error("请填写正确的手机号！");
        } else {
          if (this.show) {
            return false;
          }
          let Url = util.getAjaxUrl("axiosOne");
          this.$http
            .get(
              Url +
                "/api/user/createVliteCode?phone=" +
                this.applyForm.telNo +
                "&type=4",
              {
                headers: {
                  // 'Origin': 'http://172.20.233.129:9100',
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 200) {
                let that = this,
                  time = 60;
                var sendTimer = setInterval(function () {
                  that.show = true;
                  time--;
                  that.inner = time + "s后重新发送";
                  if (time < 0) {
                    that.show = false;
                    that.verificationCode = null;
                    clearInterval(sendTimer);
                    that.inner = "获取验证码";
                  }
                }, 1000);
              }
            });
        }
      }
    },
    // 跳转个人注册
    farenzhuce() {
      this.$router.push("/IndividualRegistration");
    },
    // 添加经办人
    addHandler() {
      this.reset();
      this.getId1();
      this.addWait = "1";
      this.addBtn = true;
      this.addOrUpdateAgent = "add";
    },
    // 增加经办人确定按钮
    yesAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id2 === true) {
            if (this.addApplyForm.scanningCopy.length == 2) {
              this.addBtn = false;
              let dataObj = Object.assign(
                {},
                JSON.parse(JSON.stringify(this.addApplyForm))
              );
              if (this.addOrUpdateAgent === "add") {
                this.applyForm.legalForms.push(dataObj);
              } else if (this.addOrUpdateAgent === "update") {
                this.applyForm.legalForms[this.tableId] = dataObj;
              }
            } else {
              Message.warning("请上传身份证正反面");
            }
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
        }
      });
    },
    // 清空增加列表
    reset() {
      this.addApplyForm.licenseList = [];
      this.addApplyForm.legalRepresentative = null;
      this.addApplyForm.certificateTypeCode = "0";
      // this.addApplyForm.certificateTypeCodeList = [];
      this.addApplyForm.certificateTypeName = null;
      this.addApplyForm.scanningCopy = [];
      this.addApplyForm.certificateNum = null;
      this.addApplyForm.termStart = null;
      this.addApplyForm.termEnd = null;
      this.addApplyForm.isLongTerm = false;
      this.addApplyForm.telNo = null;
      this.addApplyForm.email = null;
    },
    // 增加经办人取消按钮
    noAdd() {
      this.addBtn = false;
    },
    // 修改经办人
    modifyUpdate(row, index) {
      this.addWait = "2";
      this.addOrUpdateAgent = "update";
      this.tableId = index;
      this.addBtn = true;
      this.addApplyForm = row;
      this.getFile1(row.id);
    },
    // 查看经办人
    seeUpdate(row, index) {
      this.tableId = index;
      this.seeBtn = true;
      this.applyForm = row;
      // this.getFile(this.applyForm.id);
    },
    // 删除经办人
    del(row, index1) {
      this.applyForm.legalForms.forEach((item, index) => {
        if (index1 === index) {
          this.applyForm.legalForms.splice(index, 1);
        }
      });
    },
    //获取增加经办人附件
    async getFile1(val) {
      let Url = util.getAjaxUrl("axiosOne");
      await this.$http
        .get(Url + `/api/getFileListByBId?BId=${val}`)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.data == null) {
              this.$Message.warning("文件记录不存在");
            } else {
              let files = res.data.data;
              this.$set(
                this.addApplyForm,
                "scanningCopy",
                files["registerCard"]
              );
              this.addApplyForm.scanningCopy.forEach((item) => {
                item.url = Url + `/api/getPicture?path=${item.filePath}`;
              });
              this.$set(this.addApplyForm, "licenseList", files["register"]);
              this.$set(
                this.addApplyForm.licenseList[0],
                "name",
                this.addApplyForm.licenseList[0].fileOrigName
              );
            }
          }
        });
    },
    // 获取idj经办人
    getId1() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/api/common/getId").then((res) => {
        this.addApplyForm.id = res.data;
      });
    },
    // 下一步
    next1(formName) {
      this.numActi++;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.numActi == 1) {
            this.checkedwfa = false;
            this.oneJD = false;
            this.twoJD = true;
            this.preJD = true;
          } else {
            Message.warning("请选择注意协议和隐私条款");
            this.numActi--;
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
          this.numActi--;
        }
      });
    },
    next2(formName) {
      this.numActi++;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.applyForm.scanningCopy.length == 2) {
            if (this.numActi == 2) {
              let Url = util.getAjaxUrl("axiosOne");
              this.$http
                .get(
                  Url +
                    `/framework/validateCode?phone=${this.applyForm.telNo}&vCode=${this.verificationCode}`
                )
                .then((res) => {
                  if (res.status === 200) {
                    if (this.id1 === true) {
                      if (res.data.code === 200) {
                        if (res.data.data === false) {
                          Message.error(res.data.msg);
                          this.numActi--;
                        } else {
                          let dataObj = Object.assign(
                            {},
                            JSON.parse(JSON.stringify(this.applyForm))
                          );
                          this.applyForm.legalForms.push(dataObj);
                          this.checkedwfa = false;
                          this.oneJD = false;
                          this.twoJD = false;
                          this.threeJD = true;
                          this.addApplyForm.sta = false;
                        }
                      } else {
                        Message.error(res.data.msg);
                        this.numActi--;
                      }
                    } else {
                      Message.error("证件号码格式错误！");
                      this.numActi--;
                    }
                  }
                });
            }
          } else {
            Message.error("请上传身份证正反面");
            this.numActi--;
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
          this.numActi--;
        }
      });
    },
    next3() {
      this.numActi++;
      if (this.numActi == 3) {
        this.checkedwfa = true;
        this.oneJD = false;
        this.twoJD = false;
        this.threeJD = false;
        this.fourJD = true;
        this.nextJD = false;
        this.goJD = true;
      } else {
        Message.warning("有未填写内容");
        this.numActi--;
      }
    },
    // 点击注册
    regi(formName) {
      let Base64 = require("js-base64").Base64;
      this.numActi++;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id3 === true) {
            if (this.numActi == 4 && this.checked == true) {
              let Url = util.getAjaxUrl("axiosOne");
              this.applyForm.password = md5(this.applyForm.cypher);
              this.applyForm.basePassword = Base64.encode(
                this.applyForm.cypher
              );
              this.$http
                .post(Url + "/framework/register", this.applyForm)
                .then((res) => {
                  if (res.status === 200) {
                    if (res.data.code === 200) {
                      this.checkedwfa = false;
                      this.oneJD = false;
                      this.twoJD = false;
                      this.threeJD = false;
                      this.fourJD = false;
                      this.fiveJD = true;
                      this.preJD = false;
                      this.goJD = false;
                      this.dengJD = true;
                      Message.success(res.data.msg);
                    } else {
                      Message.error(res.data.msg);
                      this.numActi--;
                    }
                  } else {
                    Message.error("未知错误");
                    this.numActi--;
                  }
                });
            } else {
              Message.warning("请选择注意协议和隐私条款");
              this.numActi--;
            }
          } else {
            Message.error("两次输入密码不一致");
            this.numActi--;
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: "center",
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: "smooth",
            });
          });
          Message.warning("有未填写内容");
          this.numActi--;
        }
      });
    },
    // 上一步
    prev() {
      if (this.numActi == 1) {
        (this.checkedwfa = false), this.numActi--;
        this.oneJD = true;
        this.twoJD = false;
        this.preJD = false;
      } else if (this.numActi == 2) {
        this.applyForm.legalForms = [];
        (this.checkedwfa = false), this.numActi--;
        this.oneJD = false;
        this.twoJD = true;
        this.threeJD = false;
      } else if (this.numActi == 3) {
        (this.checkedwfa = false), this.numActi--;
        this.oneJD = false;
        this.twoJD = false;
        this.threeJD = true;
        this.fourJD = false;
        this.goJD = false;
        this.nextJD = true;
      } else {
        Message.warning("未知错误");
      }
    },
    // 手机号格式验证
    numVerification1() {
      if (this.applyForm.telNo) {
        this.getIsTelNoList(this.applyForm.telNo);
      }
    },
    numVerification2() {
      if (this.applyForm.telNo) {
        this.getIsTelNoList(this.applyForm.telNo);
      }
    },
    numVerification3() {
      if (this.applyForm.telNo) {
        this.getIsTelNoList(this.applyForm.telNo);
      }
    },
    // 判断手机号是否注册过
    getIsTelNoList(val) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        telNo: val,
        userType: "organization",
      };
      this.$http.post(Url + "/framework/compareTelNo", params).then((res) => {
        if (res.status === 200) {
          if (res.data === false) {
            this.show = true;
            if (val !== "1") {
              Message.error("该手机号已被注册！");
            }
          } else {
            this.show = false;
          }
        }
      });
    },
    // 返回首页
    goBack() {
      this.$router.push("/home");
    },
    // 返回法人登录
    personal() {
      // this.$router.push("/home");
      window.location.href = url + ":8088/#/login?type=1";
    },
    // 获取省份
    getProvinceList() {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http.get(Url + "/framework/province").then((res) => {
        if (res.status === 200) {
          this.applyForm.districtCodeList = res.data;
        }
      });
    },
    // 省份改变改变市
    districtCodeChange() {
      if (this.applyForm.districtCode) {
        this.getCityList(this.applyForm.districtCode);
        // this.applyForm.districtCode=null;
        this.applyForm.pendingDisposalNum = null;
        this.applyForm.pendingDisposalNumList = [];
        this.applyForm.processedNum = null;
        this.applyForm.processedNumList = [];
      }
    },
    // 获取市
    getCityList(val) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        parentId: val,
      };
      this.$http.post(Url + "/framework/find", params).then((res) => {
        if (res.status === 200) {
          this.applyForm.pendingDisposalNumList = res.data;
        }
      });
    },
    // 市改变改变区/县
    pendingDisposalNumChange() {
      if (this.applyForm.pendingDisposalNum) {
        this.getAreaList(this.applyForm.pendingDisposalNum);
        this.applyForm.processedNum = null;
        this.applyForm.processedNumList = [];
      }
    },
    // 获取区
    getAreaList(val) {
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        parentId: val,
      };
      this.$http.post(Url + "/framework/find", params).then((res) => {
        if (res.status === 200) {
          this.applyForm.processedNumList = res.data;
        }
      });
    },
    // 判断账号是否已存在
    userNameChange() {
      if (this.applyForm.userName !== null) {
        let Url = util.getAjaxUrl("axiosOne");
        this.$http
          .get(Url + `/framework/judge/${this.applyForm.userName}`)
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 200) {
                if (res.data.data === false) {
                  Message.error("该账号已被注册");
                }
              }
            }
          });
      }
    },
    // 验证确认密码和密码的相同
    isPasswordChange() {
      if (this.applyForm.isPassword === null) {
        Message.error("请再次输入密码");
      } else if (this.applyForm.isPassword !== this.applyForm.cypher) {
        Message.error("两次输入密码不一致");
      } else {
        this.id3 = true;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.el-upload--picture-card:hover,
/deep/.el-upload:focus {
  border-color: #2264a0 !important;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus,
/deep/.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #2264a0;
}

.box-card {
  width: 80%;
  margin: 0 auto;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: grey;
}
/deep/.el-upload-list__item.is-ready {
  display: none;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: grey;
}
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #2264a0;
}
.el-select-dropdown__item.selected {
  color: #2264a0 !important;
}
/deep/.disabled .el-upload--picture-card {
  display: none !important;
}
.formSty {
  width: 60%;
  margin: 0 auto;
}
.formSty1 {
  width: 60%;
  text-align: center;
  margin: 40px auto;
}
.seeBtn {
  border: 1px solid #2264a0;
  color: #2264a0;
  background: #e9f0f6;
  border-radius: 3px;
}
.seeBtn:hover {
  background: #2264a0;
  color: #fff;
}
.seeBtn:focus {
  background: #2264a0;
  color: #fff;
}
/deep/.el-button:focus,
/deep/.el-button:hover {
  color: #2264a0;
  border-color: #bdd1e3;
  background-color: #e9f0f6;
}
/deep/.el-upload--picture-card:hover,
.el-upload:focus {
  border-color: #2264a0;
  color: #2264a0;
}
/deep/.el-input__inner {
  height: 32px;
  border-color: black;

  // line-height: 32px;
}
/deep/.el-input__inner:hover {
  border-color: black;
}
/deep/.el-input__inner:focus {
  border-color: #2264a0;
}
/deep/.el-select .el-input.is-focus {
  border-color: #2264a0;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border-color: #2264a0;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2264a0;
}
/deep/.el-checkbox__inner:hover {
  border-color: #2264a0;
}
/deep/.el-checkbox__inner:focus {
  border-color: #2264a0;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #2264a0;
  background-color: #2264a0;
}
.active {
  color: @theme-color;
  z-index: 10;
  border-bottom: 3px solid @theme-color;
}
.register {
  width: 100%;
  margin-top: 20px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #c0c4cc;
  cursor: pointer;
  span {
    text-align: center;
    line-height: 40px;
    display: inline-block;
    height: 40px;
    width: 50%;
    font-size: 14px;
  }
}
.heiCen {
  // text-align: center;
  min-height: 600px;
}
.heiCen2 {
  min-height: 300px;
}
.smaCen {
  height: 100%;
  background: #fff;
}
.el-input-group__append {
  padding: 0;
}
.cardd {
  border: none;
}
.foot {
  text-align: center;
}
/deep/.el-button--primary {
  background: #2264a0 !important;
  color: #fff !important;
  border-color: #2264a0 !important;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}
/deep/.el-button--success {
  background: #fff !important;
  color: #2264a0 !important;
  border-color: #2264a0 !important;
  padding: 0 10px;

  height: 32px;
  line-height: 32px;
  display: inline-block;
}
</style>
